// src/components/guide/LoopDock.jsx
import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { useGuide } from '../../contexts/GuideContext';
import QuestPanel from './QuestPanel';
import TriggerCard from './TriggerCard';

const DOCK_KEY = 'spcc:guide:dock';
const R = 22, C = 28;
const point = i => { const a = (-90 + i * 60) * Math.PI / 180; return [C + R * Math.cos(a), C + R * Math.sin(a)]; };
const readOpen = () => { try { return localStorage.getItem(DOCK_KEY) === 'open'; } catch { return false; } };

export default function LoopDock() {
  const guide = useGuide();
  const [open, setOpenState] = useState(readOpen);
  if (!guide || guide.hidden || !guide.state) return null;
  const setOpen = value => { setOpenState(value); try { localStorage.setItem(DOCK_KEY, value ? 'open' : 'closed'); } catch { /* storage unavailable */ } };
  const { state, trigger } = guide;
  const habitsDone = state.habits.filter(h => h.done).length;
  const label = state.activated ? `Activation complete. Habits ${habitsDone} of ${state.habits.length}` : `Activation progress, ${state.completed} of 6`;
  return <div className="guide-dock" data-guide-ui>
    {trigger && !open && <TriggerCard result={trigger}/>}
    {open && <QuestPanel onClose={() => setOpen(false)}/>}
    <button type="button" ref={guide.dockRef} className={`guide-ring${state.activated ? ' activated' : ''}`} aria-label={label} aria-expanded={open} onClick={() => setOpen(!open)}>
      <svg viewBox="0 0 56 56" aria-hidden="true">
        {state.milestones.map((m, i) => { const [x1, y1] = point(i), [x2, y2] = point((i + 1) % 6); const lit = m.done && state.milestones[(i + 1) % 6].done; return <path key={`arc-${m.id}`} className={`guide-arc${lit ? ' lit' : ''}`} d={`M${x1} ${y1} A${R} ${R} 0 0 1 ${x2} ${y2}`} pathLength="1"/>; })}
        {state.milestones.map((m, i) => { const [x, y] = point(i); return <circle key={m.id} ref={el => guide.registerNode(m.id, el)} className={`guide-node${m.done ? ' done' : ''}`} cx={x} cy={y} r="4.5"/>; })}
      </svg>
      <span className="guide-ring-count">{state.activated ? <Check size={16}/> : `${state.completed}/6`}</span>
    </button>
    <button type="button" className="guide-bar" aria-label={label} aria-expanded={open} onClick={() => setOpen(!open)}>{state.activated ? `Habits ${habitsDone}/${state.habits.length}` : `${state.completed}/6 · ${state.next?.label}`}</button>
  </div>;
}
